import { Question, UserAnswer, AnswerChoice } from '../../../../../data/models'
import { IQuestionCorrectnestStrategy } from '..'

export class NumericEntryCorrectnessStrategy implements IQuestionCorrectnestStrategy {
  public isCorrect(question: Question, userAnswers: UserAnswer[]): boolean {
    const validChoices = question.answerChoices.filter((choice) => choice.value !== undefined && choice.value !== '')
    const answerChoiceValue = this._getAnswerChoiceFraction(validChoices)
    const userAnswerValue = this._getUserAnswerFraction(userAnswers, validChoices)
    return this._normalizeAnswer(answerChoiceValue) === this._normalizeAnswer(userAnswerValue)
  }

  // TODO [GitHub Issue]: (enhancement, need to have) Unify Correctness Algorithms |
  // Both the frontend and backend are determining correctness, and only one of them should
  // Asana: https://app.asana.com/0/273384684978995/763743051319246
  private _normalizeAnswer(value: string): string {
    let normalizedValue = value.replace(/[,%]+/, '').replace(/[:]+/, '/')
    try { normalizedValue = eval(normalizedValue) } catch (ignore) {}
    return normalizedValue
  }

  private _getAnswerChoiceFraction(choices: AnswerChoice[]): string {
    return choices.map((choice) => choice.value).join('/')
  }

  private _getUserAnswerFraction(userAnswers: UserAnswer[], choices: AnswerChoice[]): string {
    return choices.reduce((previous, choice) => {
      const userAnswer = this._getUserAnswerByChoice(userAnswers, choice)
      if (!!userAnswer) {
        previous.push(userAnswer.value)
      }
      return previous
    }, []).join('/')
  }

  private _getUserAnswerByChoice(userAnswers: UserAnswer[], choice: AnswerChoice): UserAnswer {
    return userAnswers.find((userAnswer) => choice.id === userAnswer.answerChoice.id)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/services/question-correctness/correctness-strategies/numeric-entry-correctness-strategy/numeric-entry-correctness-strategy.ts